/* eslint-disable camelcase */
import Axios from "axios";
import { logout } from "../../redux/slices/user";
import { store } from "../../redux/store";

const { REACT_APP_API_URL } = process.env;

console.log({ envs: process.env });

const request = Axios.create({
  baseURL: REACT_APP_API_URL,
});

export const getToken = () => {
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");
  return {
    accessToken,
    refreshToken,
  };
};

export const setToken = ({ accessToken = "", refreshToken = "" }) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
  }
  if (refreshToken) {
    localStorage.setItem("refreshToken", refreshToken);
  }
};

/**
 *
 * @param {string} url Endpoint URL without protocol
 * @return {string} Full URL
 */
export const setUrl = (url: string) => `${REACT_APP_API_URL}/${url}`;

request.interceptors.request.use(async (config) => {
  const jwtToken = await localStorage.getItem("accessToken");
  if (jwtToken != null) {
    config.headers = { Authorization: `Bearer ${jwtToken}` };
  }
  return config;
});

// for multiple requests
let isRefreshing = false;
let failedQueue: any[] = [];

const processQueue = (error: any, token: string = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

request.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return Axios(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise((resolve, reject) => {
        const { accessToken, refreshToken } = getToken();
        Axios.post(setUrl("auth/refresh"), null, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Refresh-Token": refreshToken,
          },
        })
          .then(({ data: { access_token, refresh_token } }) => {
            setToken({
              accessToken: access_token,
              refreshToken: refresh_token,
            });
            Axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
            originalRequest.headers.Authorization = `Bearer ${access_token}`;
            processQueue(null, access_token);
            Axios(originalRequest)
              .then(resolve)
              .catch((err) => {
                if (Axios.isAxiosError(err) && err.response.status === 401) {
                  store.dispatch(logout());
                  reject(err);
                } else {
                  reject(err);
                }
              });
          })
          .then(() => {
            isRefreshing = false;
          })
          .catch((err) => {
            processQueue(err, null);
            if (Axios.isAxiosError(err) && err.response.status === 401) {
              store.dispatch(logout());
            }
            reject(err);
          });
      });
    }

    return Promise.reject(error);
  }
);

const API = request;
export default API;
